export default __webpack_public_path__ + "static/media/faculty_icon1.f04ea12f.svg";